import { Globe } from "lucide-react";
import Image from "next/image";

/**
 * Per-source-type logo URL keyed by both the legacy SourceType enum value
 * (``"Google Drive"``) and the case-variants we've shipped over time
 * (``"SharePoint"`` vs ``"Sharepoint"``). Datasources without an entry
 * fall back to a globe icon — register their image URL here when adding
 * a new source.
 */
export const SOURCE_TYPE_ICONS: Record<string, string> = {
  "Google Drive":
    "https://storage.googleapis.com/image-storage-spot-manual/logos/google-drive.svg",
  OneDrive:
    "https://storage.googleapis.com/image-storage-spot-manual/logos/onedrive.png",
  Sharepoint:
    "https://storage.googleapis.com/image-storage-spot-manual/logos/sharepoint.png",
  SharePoint:
    "https://storage.googleapis.com/image-storage-spot-manual/logos/sharepoint.png",
  ServiceNow:
    "https://storage.googleapis.com/image-storage-spot-manual/logos/servicenow.png",
};

export function SourceIcon({
  sourceType,
  size = 16,
  imageUrl,
}: {
  sourceType: string;
  size?: number;
  // Explicit icon URL — used for plugin datasources, whose icon isn't a fixed
  // enum entry but travels in the document's source_metadata. A plain <img>
  // (not next/image) so an arbitrary plugin-supplied domain renders.
  imageUrl?: string | null;
}) {
  if (imageUrl) {
    return <img src={imageUrl} alt={sourceType} width={size} height={size} />;
  }
  const icon = SOURCE_TYPE_ICONS[sourceType];
  if (icon) {
    return <Image src={icon} alt={sourceType} width={size} height={size} />;
  }
  return (
    <Globe
      size={size - 2}
      className="text-muted-foreground"
      strokeWidth={1.5}
    />
  );
}
